var map = {
	"./hw_days_1950.jpg": 779536,
	"./hw_days_1951.jpg": 228735,
	"./hw_days_1952.jpg": 857440,
	"./hw_days_1953.jpg": 956932,
	"./hw_days_1954.jpg": 428108,
	"./hw_days_1955.jpg": 865371,
	"./hw_days_1956.jpg": 897572,
	"./hw_days_1957.jpg": 768872,
	"./hw_days_1958.jpg": 81380,
	"./hw_days_1959.jpg": 390680,
	"./hw_days_1960.jpg": 751708,
	"./hw_days_1961.jpg": 272948,
	"./hw_days_1962.jpg": 745524,
	"./hw_days_1963.jpg": 813168,
	"./hw_days_1964.jpg": 925396,
	"./hw_days_1965.jpg": 368904,
	"./hw_days_1966.jpg": 645112,
	"./hw_days_1967.jpg": 974936,
	"./hw_days_1968.jpg": 877948,
	"./hw_days_1969.jpg": 437176,
	"./hw_days_1970.jpg": 401868,
	"./hw_days_1971.jpg": 406967,
	"./hw_days_1972.jpg": 390172,
	"./hw_days_1973.jpg": 279725,
	"./hw_days_1974.jpg": 634712,
	"./hw_days_1975.jpg": 289380,
	"./hw_days_1976.jpg": 847856,
	"./hw_days_1977.jpg": 41332,
	"./hw_days_1978.jpg": 757476,
	"./hw_days_1979.jpg": 246172,
	"./hw_days_1980.jpg": 664576,
	"./hw_days_1981.jpg": 930268,
	"./hw_days_1982.jpg": 977248,
	"./hw_days_1983.jpg": 342920,
	"./hw_days_1984.jpg": 440748,
	"./hw_days_1985.jpg": 732972,
	"./hw_days_1986.jpg": 570124,
	"./hw_days_1987.jpg": 792188,
	"./hw_days_1988.jpg": 601019,
	"./hw_days_1989.jpg": 833668,
	"./hw_days_1990.jpg": 854484,
	"./hw_days_1991.jpg": 360036,
	"./hw_days_1992.jpg": 280172,
	"./hw_days_1993.jpg": 357040,
	"./hw_days_1994.jpg": 898392,
	"./hw_days_1995.jpg": 535412,
	"./hw_days_1996.jpg": 579512,
	"./hw_days_1997.jpg": 548640,
	"./hw_days_1998.jpg": 975792,
	"./hw_days_1999.jpg": 75560,
	"./hw_days_2000.jpg": 622116,
	"./hw_days_2001.jpg": 852512,
	"./hw_days_2002.jpg": 699468,
	"./hw_days_2003.jpg": 165184,
	"./hw_days_2004.jpg": 765948,
	"./hw_days_2005.jpg": 549124,
	"./hw_days_2006.jpg": 455335,
	"./hw_days_2007.jpg": 144880,
	"./hw_days_2008.jpg": 953340,
	"./hw_days_2009.jpg": 512568,
	"./hw_days_2010.jpg": 37144,
	"./hw_days_2011.jpg": 54663,
	"./hw_days_2012.jpg": 745660,
	"./hw_days_2013.jpg": 594720,
	"./hw_days_2014.jpg": 866388,
	"./hw_days_2015.jpg": 654672,
	"./hw_days_2016.jpg": 149308,
	"./hw_days_2017.jpg": 837404,
	"./hw_days_2018.jpg": 174659,
	"./hw_days_2019.jpg": 80864,
	"./hw_days_2020.jpg": 72764,
	"./hw_days_2021.jpg": 307700,
	"./hw_days_2022.jpg": 949428,
	"./hw_days_2023.jpg": 977760,
	"./hw_days_2024.jpg": 4324,
	"./hw_events_1950.jpg": 303380,
	"./hw_events_1951.jpg": 536080,
	"./hw_events_1952.jpg": 102652,
	"./hw_events_1953.jpg": 940656,
	"./hw_events_1954.jpg": 863640,
	"./hw_events_1955.jpg": 331344,
	"./hw_events_1956.jpg": 488983,
	"./hw_events_1957.jpg": 280519,
	"./hw_events_1958.jpg": 923692,
	"./hw_events_1959.jpg": 209460,
	"./hw_events_1960.jpg": 414664,
	"./hw_events_1961.jpg": 541780,
	"./hw_events_1962.jpg": 276908,
	"./hw_events_1963.jpg": 912620,
	"./hw_events_1964.jpg": 829884,
	"./hw_events_1965.jpg": 592228,
	"./hw_events_1966.jpg": 415644,
	"./hw_events_1967.jpg": 987692,
	"./hw_events_1968.jpg": 471789,
	"./hw_events_1969.jpg": 914560,
	"./hw_events_1970.jpg": 956920,
	"./hw_events_1971.jpg": 883240,
	"./hw_events_1972.jpg": 772044,
	"./hw_events_1973.jpg": 173296,
	"./hw_events_1974.jpg": 848824,
	"./hw_events_1975.jpg": 127372,
	"./hw_events_1976.jpg": 504368,
	"./hw_events_1977.jpg": 220188,
	"./hw_events_1978.jpg": 259172,
	"./hw_events_1979.jpg": 240292,
	"./hw_events_1980.jpg": 560724,
	"./hw_events_1981.jpg": 156268,
	"./hw_events_1982.jpg": 633028,
	"./hw_events_1983.jpg": 937412,
	"./hw_events_1984.jpg": 893964,
	"./hw_events_1985.jpg": 781256,
	"./hw_events_1986.jpg": 638368,
	"./hw_events_1987.jpg": 313024,
	"./hw_events_1988.jpg": 656372,
	"./hw_events_1989.jpg": 832048,
	"./hw_events_1990.jpg": 278500,
	"./hw_events_1991.jpg": 259620,
	"./hw_events_1992.jpg": 310588,
	"./hw_events_1993.jpg": 793256,
	"./hw_events_1994.jpg": 488464,
	"./hw_events_1995.jpg": 6364,
	"./hw_events_1996.jpg": 376628,
	"./hw_events_1997.jpg": 204724,
	"./hw_events_1998.jpg": 976248,
	"./hw_events_1999.jpg": 124948,
	"./hw_events_2000.jpg": 978628,
	"./hw_events_2001.jpg": 38592,
	"./hw_events_2002.jpg": 185052,
	"./hw_events_2003.jpg": 480588,
	"./hw_events_2004.jpg": 814772,
	"./hw_events_2005.jpg": 390128,
	"./hw_events_2006.jpg": 807628,
	"./hw_events_2007.jpg": 389432,
	"./hw_events_2008.jpg": 852848,
	"./hw_events_2009.jpg": 274968,
	"./hw_events_2010.jpg": 203136,
	"./hw_events_2011.jpg": 40288,
	"./hw_events_2012.jpg": 262351,
	"./hw_events_2013.jpg": 879124,
	"./hw_events_2014.jpg": 680372,
	"./hw_events_2015.jpg": 297916,
	"./hw_events_2016.jpg": 183760,
	"./hw_events_2017.jpg": 394560,
	"./hw_events_2018.jpg": 211024,
	"./hw_events_2019.jpg": 425132,
	"./hw_events_2020.jpg": 729004,
	"./hw_events_2021.jpg": 52484,
	"./hw_events_2022.jpg": 875356,
	"./hw_events_2023.jpg": 311860,
	"./hw_events_2024.jpg": 976192,
	"./hw_meanmag_1950.jpg": 194628,
	"./hw_meanmag_1951.jpg": 167268,
	"./hw_meanmag_1952.jpg": 248960,
	"./hw_meanmag_1953.jpg": 325201,
	"./hw_meanmag_1954.jpg": 424796,
	"./hw_meanmag_1955.jpg": 632596,
	"./hw_meanmag_1956.jpg": 683284,
	"./hw_meanmag_1957.jpg": 393648,
	"./hw_meanmag_1958.jpg": 85100,
	"./hw_meanmag_1959.jpg": 358916,
	"./hw_meanmag_1960.jpg": 537624,
	"./hw_meanmag_1961.jpg": 521680,
	"./hw_meanmag_1962.jpg": 638892,
	"./hw_meanmag_1963.jpg": 105536,
	"./hw_meanmag_1964.jpg": 493716,
	"./hw_meanmag_1965.jpg": 283712,
	"./hw_meanmag_1966.jpg": 699252,
	"./hw_meanmag_1967.jpg": 614640,
	"./hw_meanmag_1968.jpg": 897520,
	"./hw_meanmag_1969.jpg": 527144,
	"./hw_meanmag_1970.jpg": 791972,
	"./hw_meanmag_1971.jpg": 975244,
	"./hw_meanmag_1972.jpg": 963479,
	"./hw_meanmag_1973.jpg": 886720,
	"./hw_meanmag_1974.jpg": 462632,
	"./hw_meanmag_1975.jpg": 455284,
	"./hw_meanmag_1976.jpg": 46604,
	"./hw_meanmag_1977.jpg": 863276,
	"./hw_meanmag_1978.jpg": 546492,
	"./hw_meanmag_1979.jpg": 247728,
	"./hw_meanmag_1980.jpg": 905552,
	"./hw_meanmag_1981.jpg": 356744,
	"./hw_meanmag_1982.jpg": 106940,
	"./hw_meanmag_1983.jpg": 375692,
	"./hw_meanmag_1984.jpg": 204895,
	"./hw_meanmag_1985.jpg": 67367,
	"./hw_meanmag_1986.jpg": 974892,
	"./hw_meanmag_1987.jpg": 312936,
	"./hw_meanmag_1988.jpg": 760888,
	"./hw_meanmag_1989.jpg": 177008,
	"./hw_meanmag_1990.jpg": 253404,
	"./hw_meanmag_1991.jpg": 45476,
	"./hw_meanmag_1992.jpg": 688764,
	"./hw_meanmag_1993.jpg": 823244,
	"./hw_meanmag_1994.jpg": 527072,
	"./hw_meanmag_1995.jpg": 890092,
	"./hw_meanmag_1996.jpg": 342820,
	"./hw_meanmag_1997.jpg": 710320,
	"./hw_meanmag_1998.jpg": 673156,
	"./hw_meanmag_1999.jpg": 433132,
	"./hw_meanmag_2000.jpg": 368308,
	"./hw_meanmag_2001.jpg": 572472,
	"./hw_meanmag_2002.jpg": 819696,
	"./hw_meanmag_2003.jpg": 991688,
	"./hw_meanmag_2004.jpg": 608876,
	"./hw_meanmag_2005.jpg": 823380,
	"./hw_meanmag_2006.jpg": 224728,
	"./hw_meanmag_2007.jpg": 306492,
	"./hw_meanmag_2008.jpg": 14696,
	"./hw_meanmag_2009.jpg": 596076,
	"./hw_meanmag_2010.jpg": 689784,
	"./hw_meanmag_2011.jpg": 957216,
	"./hw_meanmag_2012.jpg": 382312,
	"./hw_meanmag_2013.jpg": 496604,
	"./hw_meanmag_2014.jpg": 433528,
	"./hw_meanmag_2015.jpg": 714420,
	"./hw_meanmag_2016.jpg": 231364,
	"./hw_meanmag_2017.jpg": 536408,
	"./hw_meanmag_2018.jpg": 343208,
	"./hw_meanmag_2019.jpg": 458868,
	"./hw_meanmag_2020.jpg": 412372,
	"./hw_meanmag_2021.jpg": 9064,
	"./hw_meanmag_2022.jpg": 873248,
	"./hw_meanmag_2023.jpg": 557071,
	"./hw_meanmag_2024.jpg": 34940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 753584;